import * as React from 'react'
import { Col, Row } from 'react-bootstrap'

interface Props {
	text?: string
	large?: boolean
	style?: React.CSSProperties
	rowstyle?: React.CSSProperties
	children?: React.ReactNode
}

const SubtitleComponent = ({ text, children, large, style: styleProp, rowstyle }: Props) => {
	const style: React.CSSProperties = {
		paddingBottom: '20px',
		paddingTop: large ? '40px' : '10px',
		...rowstyle,
	}
	const textStyle: React.CSSProperties = {
		fontSize: large ? '36px' : '30px',
		...styleProp,
	}

	return (
		<Row style={style}>
			<Col md={11}>
				<div style={textStyle} className="company-name text-info">
					{text ?? children}
				</div>
			</Col>
		</Row>
	)
}

export default SubtitleComponent
